<template>
  <div>
    <data-list class="select_checkbox_column_width_0" :payload="warehouseDataObj" :headers="headers" v-model="pagination" :total="total" :pagination="pagination">
      <v-container fluid grid-list-xl slot="filterForm">
        <v-layout row class="mb-0">
          <v-flex lg3 xs12>
            <v-btn color="primary"  dark class="mt-4" @click="openDialogHandler">{{$t('message.common.addNew')}}</v-btn>
          </v-flex>
          <v-spacer></v-spacer>
          <v-flex lg3 class="text-end pt-0">
            <v-text-field persistent-hint :hint="$t('message.common.searchTriggerHint')" clearable outlined dense append-icon="search" @keyup.enter="getListHandler" @click:append="getListHandler" single-line v-model="search" :label="$t('message.common.search')" class="text-xs-right pt-3 search-hint-padding" id="searchbtn"></v-text-field>
          </v-flex>
        </v-layout>
      </v-container>
    </data-list>
    <v-dialog v-model="dialog" width="750" persistent>
      <form-template :references.sync="formReferences" :model="warehouseObj" ref="warehouseReference"></form-template>
    </v-dialog>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import DataList from '../../components/DataList.vue'
import FormTemplate from '../../components/FormTemplate'
export default {
  data () {
    return {
      total: 0,
      dialog: false,
      warehouseObj: { isactive: true },
      search: '',
      warehouseDataObj: {
        isHeader: true,
        isHideAdd: true,
        hasFilters: true,
        isStock: true,
        selection: [],
        showSelect: true,
        list: [],
        loading: false,
        page: 1,
        editProp: 'name',
        addClickHandler: this.openDialogHandler,
        editHandler: this.getSingleWarehouseHandler
      },
      loading: false,
      pagination: !this.$formatter.isEmptyObject(this.$store.state.WAREHOUSE_SETTINGS) ? this.$store.state.WAREHOUSE_SETTINGS : { sortBy: ['name'], itemsPerPage: 25, sortDesc: [false], search: '' }
    }
  },
  components: {
    DataList,
    FormTemplate
  },
  computed: {
    headers () {
      return [{
        text: this.$t('message.customer.name'),
        value: 'name',
        isRoute: true,
        isModal: true,
        width: '30%'
      }, {
        text: this.$t('message.deviations.responsible'),
        value: 'user_firstname',
        sortable: true,
        width: '25%'
      }, {
        text: this.$t('message.customer.notificationEmail'),
        value: 'notificationmail',
        sortable: true,
        width: '25%'
      }, {
        text: this.$t('message.common.isActive'),
        value: 'isactive',
        isBoolean: true,
        sortable: false,
        width: '10%'
      }]
    },
    ...mapState(['FORM_TYPE', 'listOfUsers']),
    formReferences () {
      return {
        title: this.warehouseObj.id ? this.$t('message.warehouse.updateWarehouse') : this.$t('message.warehouse.addWarehouse'),
        properties: [{
          model: 'name',
          type: this.FORM_TYPE.TEXT,
          rules: this.$_requiredValidation,
          label: this.$t('message.customer.name'),
          class: 'xs6'
        }, {
          model: 'responsibleid',
          rules: [],
          type: this.FORM_TYPE.AUTO_COMPLETE,
          class: 'xs6',
          items: this.listOfUsers,
          select_text: 'firstname',
          select_value: 'id',
          label: this.$t('message.deviations.responsible')
        }, {
          model: 'notificationmail',
          type: this.FORM_TYPE.TEXT,
          rules: this.$_emailValidation,
          label: this.$t('message.customer.notificationEmail'),
          class: 'xs6'
        }, {
          model: 'isactive',
          rules: [],
          type: this.FORM_TYPE.CHECKBOX,
          class: 'xs6 my-auto',
          label: this.$t('message.common.isActive')
        }],
        buttons: [{
          name: 'action_handler',
          color: 'success',
          label: this.warehouseObj.id ? this.$t('message.common.update') : this.$t('message.common.save'),
          click: this.saveUpdateHandler,
          loading: this.loading,
          is_show: true
        }, {
          name: 'close',
          color: 'error',
          click: this.closeDialogHandler,
          label: this.$t('message.common.close'),
          is_show: true
        }]
      }
    }
  },
  watch: {
    pagination: {
      handler (val) {
        this.rememberPagination(val)
        this.getListHandler()
      },
      deep: true
    },
    search (val) {
      let pagination = this.$formatter.cloneVariable(this.pagination)
      pagination.search = val
      this.rememberPagination(pagination)
      if (!val) this.getListHandler()
    }
  },
  mounted () {
    this.search = this.pagination.search || ''
    let text = this.$t('message.common.deleteMsg')
    this.$eventBus.$on('deleteItems', (data) => {
      if (data.module === this.WAREHOUSE) {
        let payload = { ids: data.ids, url: `${this.WAREHOUSE}/delete_multiple`, module: 'warehouses' }
        this.$store.commit('showDeleteDialog', payload)
      }
    })
    this.$eventBus.$on('deleteSuccess', (data) => {
      if (data === this.WAREHOUSE) {
        this.warehouseDataObj.selection = []
        this.$root.$emit('snackbar', { snackbar: true, color: 'success', text })
        this.$store.commit('hideDialog')
        this.getListHandler()
      }
    })
    this.$store.dispatch('getUsers')
  },
  methods: {
    rememberPagination (pagination) {
      let model = {
        type: 'WAREHOUSE_SETTINGS',
        data: pagination
      }
      this.$store.commit('rememberOrder', model)
    },
    getListHandler () {
      this.warehouseDataObj.loading = true
      this.warehouseDataObj.module = this.WAREHOUSE
      let fields = this.$formatter.cloneVariable(this.headers)
      fields.splice(1, 2)
      let queryFields = fields
      let { page, sortBy, sortDesc, itemsPerPage } = this.$formatter.cloneVariable(this.pagination)
      let pageVal = page || 1
      let sort = queryFields.find(x => x.value === sortBy[0])
      let query = {
        'expand': [{
          'select': ['firstname'],
          'model': 'User',
          'on_field': 'id',
          'on_parent_field': 'responsibleid',
          'filter': `firstname contains '${this.search}'`,
          'order_by': {
            'field': sortBy[0] === 'user_firstname' ? 'firstname' : null,
            'asc_or_desc': sortBy[0] === 'user_firstname' ? sortDesc[0] ? 'desc' : 'asc' : null
          }
        }/* , {
          'select': ['name'],
          'model': 'Department',
          'on_field': 'id',
          'on_parent_field': 'departmentid',
          'filter': `name contains '${this.search}'`,
          'order_by': {
            'field': sortBy[0] === 'department_name' ? 'name' : null,
            'asc_or_desc': sortBy[0] === 'department_name' ? sortDesc[0] ? 'desc' : 'asc' : null
          }
        } */ ],
        'order_by': {
          'field': sort ? sort.value : null,
          'asc_or_desc': sortDesc[0] ? 'desc' : 'asc'
        },
        'skip': ((pageVal - 1) * itemsPerPage),
        'limit': itemsPerPage,
        'include_count': true,
        'filter': `${queryFields.map(x => x.value).join(` contains '${this.search || ''}' OR `)} contains '${this.search || ''}'`
      }
      this.$_executeApi('post', 'warehouses/query', query)
        .then((response) => {
          let { values, count } = response.data
          this.warehouseDataObj.loading = false
          this.warehouseDataObj.list = values
          this.total = count
          if (this.pagination.page > 1 && this.total <= this.pagination.itemsPerPage * (this.pagination.page - 1)) {
            this.pagination.page = 1
            this.warehouseDataObj.page = 1
          }
        })
    },
    getSingleWarehouseHandler (id) {
      this.$_getSingleRecordHandler(`warehouses/${id}`)
        .then((result) => {
          if (result.data) this.warehouseObj = result.data
          this.dialog = true
        })
    },
    openDialogHandler () {
      this.dialog = true
      this.warehouseObj.isactive = true
    },
    closeDialogHandler () {
      this.dialog = false
      this.warehouseObj.id = undefined
      this.$refs.warehouseReference.$refs.validateForm.reset()
    },
    saveUpdateHandler () {
      if (this.$refs.warehouseReference.$refs.validateForm.validate()) {
        this.loading = true
        let model = this.warehouseObj
        let url = 'warehouses'
        this.$_saveUpdateHandler(url, model)
          .then(() => {
            this.closeDialogHandler()
            this.getListHandler()
            this.loading = false
          })
          .finally(() => {
            this.loading = false
          })
      } else this.$root.$emit('snackbar', { snackbar: true, color: 'error', text: this.$t('message.common.validationIssue') })
    },
    supportingList (type, text) {
      const modelName = text
      text = this.$refs.warehouseReference.$refs[text][0].lazySearch
      let model = { module: type, dialog: true, text, modelName }
      this.$store.commit('supportingList', model)
    }
  },
  beforeDestroy () {
    this.$eventBus.$off('deleteSuccess')
    this.$eventBus.$off('deleteItems')
  }
}
</script>
